import type { Query } from '@rota/contracts';

/**
 * Consulta padrão do modo ao vivo (Hoje, sem replay, comparação com ontem até a mesma hora, sem
 * filtro). Regra única: o snapshot do provider e o hook da moldura usam esta mesma função.
 */
export function isDefaultLiveQuery(q: Query): boolean {
  return (
    q.range.preset === 'today' &&
    q.asOf === undefined &&
    q.compare === 'yesterday_same_time' &&
    Object.values(q.filters ?? {}).every((v) => v == null || (Array.isArray(v) && v.length === 0))
  );
}
